module.exports = __webpack_public_path__ + "static/media/galerija_2017 (22).377b9c9e.jpg";